import DocumentService from "../services/document.service";


class DownloadDocument {
    documentService = new DocumentService();
       /**
     * Description
     * -----------
     * This method is to download the file
     * Parameters:
     * fileName: file which needs to be download
     */
    async  handleDownload(fileName, promptId) {
        const response = await this.documentService.GetDownlodedDocument(
            promptId,
            fileName
        );
        if (response) {
            const type = response.type;
            const blob = new Blob([response], { type: type });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
        }
    }
    
    /**
     * To get Documents PDF url
     * @param {*} fileName 
     * @returns 
     */
    async  getDownloadUrl(fileName, promptId) {
        if (fileName) {
            const response = await this.documentService.GetDownlodedDocument(
                promptId,
                fileName,
            );
            if (response) {
                const type = response.type;
                const blob = new Blob([response], { type: type });
                let url = window.URL.createObjectURL(blob);
                return url;
            }
        }
    }

     /**
     * To get Documents PDF url
     * @param {*} fileName 
     * @returns 
     */
      async getFileExcel(fileName, promptId) {
        if (fileName) {
            const response = await this.documentService.GetDownlodedDocument(
                promptId,
                fileName
            );
            if (response) {
                return response;
            }
        }
    }
}
export default DownloadDocument;